import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
  getSelectedEvent,
  getSelectedTimeslot,
  useAppContext,
} from "../../contextProviders/AppContext";
import { TimeSlot, CSSEvent } from "../../types/model";
import ConditionalRender from "../ConditionalRender";
import QuantityWithLabel from "../QuantityWithLabel";
import getMaxGuestCount from "./getMaxGuestCount";

type PropsType = {
  onChangeQuantity: Function;
};

const QuantityWrapper = styled.div`
  display: flex;
  > div:first-child {
    margin-right: var(--space-200);
  }

  ${({ theme }) => `${theme.breakpoints.lg} {
    flex-direction: column;
    flex-wrap: wrap;
    flex-direction: row;
  }`}
`;

const InputWrapper = styled.div`
  margin-bottom: var(--space-100);
`;

const Wrapper = styled.div`
  margin: 0 0 var(--space-200);
`;

const Header = styled.h3`
  margin-bottom: var(--space-100);
  ${({ theme }) => `${theme.breakpoints.lg} {
    margin-bottom: var(--space-150);
  }`}
`;

const Guests = ({ onChangeQuantity }: PropsType) => {
  const { t } = useTranslation();
  const { useSelector } = useAppContext();
  const selectedEvent = useSelector(getSelectedEvent) as CSSEvent;
  const selectedTimeslot = useSelector(getSelectedTimeslot) as TimeSlot;
  const { maxAdditionalGuests, maxAmountChildren } = getMaxGuestCount(
    selectedTimeslot.remainingSpots,
    selectedEvent?.registrationSettings?.participantsPerRegistration,
    selectedEvent?.registrationSettings?.childrenPerRegistration,
    selectedEvent?.registrationSettings?.childrenIncludedInCount
  );
  const showAdditionalGuests = maxAdditionalGuests > 0;
  const showChildren = maxAmountChildren > 0;

  return (
    <ConditionalRender predicate={showAdditionalGuests || showChildren}>
      <Wrapper>
        <Header>{t("register.whoElse")}</Header>
        <QuantityWrapper>
          <ConditionalRender predicate={showAdditionalGuests}>
            <InputWrapper>
              <QuantityWithLabel
                id="guests-quantity"
                label={t("register.noOfAdditional")}
                min={0}
                max={maxAdditionalGuests}
                onChange={onChangeQuantity("guests")}
              />
            </InputWrapper>
          </ConditionalRender>
          <ConditionalRender predicate={showChildren}>
            <InputWrapper>
              <QuantityWithLabel
                id="children-quantity"
                label={t("register.noOfChildern")}
                min={0}
                max={maxAmountChildren}
                onChange={onChangeQuantity("children")}
              />
            </InputWrapper>
          </ConditionalRender>
        </QuantityWrapper>
      </Wrapper>
    </ConditionalRender>
  );
};

export default Guests;
